<template>
  <label>
    <span v-show="label" class="label-text">{{ label }}</span>
    <textarea v-model.trim="vModel" :maxlength="maxlength" :placeholder="placeholder" rows="2" type="text" />
  </label>
</template>

<script>
export default {
  name: 'BookingFormTextarea',
  props: {
    label: {
      type: String,
      default: '',
    },
    maxlength: {
      type: Number,
      default: 0,
    },
    placeholder: {
      type: String,
    },
    value: {
      type: String,
    },
  },
  computed: {
    vModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

label,
textarea {
  width: 100%;
}

label,
.label-text {
  display: block;
}

label {
  margin-bottom: 28px;
}

.label-text {
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
}

textarea {
  resize: vertical;
  min-height: 50px;
  padding: 6px 12px;
  font-size: 14px;
  font-weight: 400;
  color: vars.$c-dark-gray;
  border: 1px solid vars.$c-gray-a2;

  &::placeholder {
    color: rgba(vars.$c-dark-gray, 0.7);
  }

  @media (min-width: vars.$tablet-break-point) {
    font-size: 16px;
  }
}
</style>
